export default "__VITE_ASSET__b94466b8__"